/* eslint-disable @next/next/no-img-element */
"use client";

import { useAuthContext } from "@/contexts/common/AuthContextProvider";
import { BASE_URL_ORIGINAL_PADDOCKS } from "@/utils/common/baseUrls";
import { ROUTE_LABELS } from "@/utils/common/translations";
import { NavLayout } from "@getaddify/lux";
import { clsx } from "clsx";
import { useSelectedLayoutSegments } from "next/navigation";
import { EnvironmentLogo } from "@/components/common/EnvironmentBranding";

export default function NavContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, logout } = useAuthContext();

  const userActions = {
    onLogoutClick: () => {
      logout();
    },
  };

  const segments = useSelectedLayoutSegments();

  return (
    <NavLayout
      className="md:grid-cols-[12rem_1fr]"
      customLogo={
        <EnvironmentLogo
          src="/icons/AddifyLogo_Transparent.png"
          alt="Addify Logo"
          className="h-8"
        />
      }
      sideBarClassName={clsx(
        "[&_a:hover]:bg-primary",
        "[&_a:hover]:text-white",
        "[&_a.bg-orange-100]:bg-[#f3cbcb]",
        "[&_a.bg-orange-100]:text-black"
      )}
      menuSections={[
        {
          name: "Main",
          position: "top",
          items: !!user
            ? [
                {
                  icon: "house-blank",
                  label: ROUTE_LABELS.HOME,
                  href: "/",
                  isActive: segments.length === 0,
                },
                {
                  icon: "buildings",
                  label: ROUTE_LABELS.COMPANIES,
                  href: "/companies",
                  isActive: segments[0] === "companies",
                },
                {
                  icon: "cars",
                  label: ROUTE_LABELS.VEHICLES,
                  href: `/vehicles`,
                  isActive: segments[0] === "vehicles",
                },
                {
                  icon: "ruler",
                  label: ROUTE_LABELS.UNDERWRITING,
                  href: `${BASE_URL_ORIGINAL_PADDOCKS}/underwriting`,
                },
                /*{
                  icon: "money-bill-1-wave",
                  label: ROUTE_LABELS.FINANCE,
                  href: "/finance",
                  isActive: segments[0] === "finance",
                },*/
                {
                  icon: "users",
                  label: ROUTE_LABELS.USERS,
                  href: `${BASE_URL_ORIGINAL_PADDOCKS}/users`,
                },
                {
                  icon: "chart-line-up",
                  label: "Status",
                  href: "/status",
                  isActive: segments[0] === "status",
                },
              ]
            : [
                {
                  icon: "house-blank",
                  label: ROUTE_LABELS.HOME,
                  href: "/",
                  isActive: true,
                },
              ],
        },
      ]}
      user={user}
      userActions={userActions}
    >
      {children}
    </NavLayout>
  );
}
